import React, { useState  , useEffect } from "react";
import styled from "styled-components";
import { SketchPicker } from "react-color";

const ColorToggler = styled.div`
  padding: 5px;
  background: #fff;
  border-radius: 1px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  display: inline-block;
  cursor: pointer;
`;

const Color = styled.div`
  width: 36px;
  height: 14px;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  background: ${(props) =>
    props.selectedColor ? props.selectedColor : "transparent"};
`;

const Popover = styled.div`
  position: absolute;
  margin-top: 7px;
  margin-left: -5px;
  z-index: 2;
`;

const StyledSketch = styled(SketchPicker)`
  &[style] {
    background: #1e2832 !important;
  }
`;

const defaultColor = {
  hex: "#fff"
};

export default function ColorPicker({ color, onChangeCallback }) {
  const initialColor = color ? color : defaultColor;
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [selectedColor, setSelectedColor] = useState(initialColor);

  useEffect(() => {
    setSelectedColor(color);
  },[color])
  
  return (
    <div>
      <ColorToggler onClick={() => setDisplayColorPicker(!displayColorPicker)}>
        <Color selectedColor={selectedColor.hex} />
        {displayColorPicker ? (
          <Popover onClick={(e) => e.stopPropagation()}>
            <StyledSketch
              color={selectedColor}
              onChange={(newColor) => {
                setSelectedColor(newColor);
                onChangeCallback(newColor);
              }}
            />
          </Popover>
        ) : null}
      </ColorToggler>
    </div>
  );
  
}
